(function (root, factory) {
	'use strict';

	if (typeof define === 'function' && define.amd) {
		// AMD
		define(['components/utilities/utilities'], factory);
	} else if (typeof exports === 'object') {
		// Node, CommonJS-like
		module.exports = factory(require('components/utilities/utilities'));
	} else {
		// Browser globals (root is window)
		root.s5SToggleLink = factory(root.s5Utils);
	}
}(this, function (utils) {
	'use strict';

	/**
	 * Toggle link
	 * A plugin for making links toggle other content (with accessibility features).
	 * @version 1.1.5
	 * @exports toggleLink
	 */
	var toggleLink = {

		openDropdown: null,

		/**
		 * The initialization function for this module.
		 * @public
		 */
		init: function () {
			this._initToggleLink();

			if (document.querySelector('.toggle-dropdown') !== null) {
				this._attachOutsideClickEvent();
			}
		},


		/**
		 * Add toggle feature to the links.
		 * @private
		 */
		_initToggleLink: function () {
			var that = this;

			utils.forEachElement('[data-type="toggle"]', function (el) {
				var target = document.getElementById(el.getAttribute('aria-controls'));

				if (el.tagName.toLowerCase() === 'a' && el.getAttribute('role') === null) {
					el.setAttribute('role', 'button');
				}

				utils.addEventListener(el, 'click', function (event) {
					var evt = event || window.event,
						currentState = target.getAttribute('aria-hidden') === 'true',
						currentText = this.innerHTML,
						nextText = this.getAttribute('data-toggletext') || currentText,
						group = target.getAttribute('data-togglegroup'),
						dropdown = utils.hasClass(el.parentNode, 'toggle-dropdown') ? el.parentNode : null;

					if (evt.preventDefault !== undefined) { evt.preventDefault(); } else { evt.returnValue = false; }
					if (evt.stopPropagation !== undefined) { evt.stopPropagation(); }

					// Close other toggles that are opened in this group.
					if (group !== undefined) {
						utils.forEachElement('[data-togglegroup="' + group + '"][aria-hidden="false"]', function (groupEl) {
							var groupElId = groupEl.getAttribute('id');
							document.querySelector('[href="#' + groupElId + '"]').click();
						});
					}

					target.setAttribute('aria-hidden', !currentState);
					this.setAttribute('aria-expanded', currentState);
					this.setAttribute('data-toggletext', currentText);
					this.innerHTML = nextText;
					utils.rerenderElement('lt-ie9');

					if (currentState === true) {
						utils.addClass(this, 'is-active');

						if (dropdown) {
							that.openDropdown = this;
						}

						if (target.querySelector('input[type="text"]') !== null) {
							target.querySelector('input[type="text"]').focus();
						}
						else if (target.querySelector('input[type="search"]') !== null) {
							target.querySelector('input[type="search"]').focus();
						} else {
							if (target.getAttribute('tabindex') === null) {
								target.setAttribute('tabindex', '-1');
							}
							target.focus();
						}
					} else {
						utils.removeClass(this, 'is-active');
						that.openDropdown = null;
					}
				});
			});
		},


		/**
		 * Attach an click-event to the window object that hides open dropdown on click outside them.
		 * @private
		 */
		_attachOutsideClickEvent: function () {
			var that = this;

			utils.addEventListener(window, 'click', function (event) {
				if (that.openDropdown !== null) {
					var currentTag = event.target;

					while (currentTag !== null && utils.hasClass(currentTag, 'toggle-dropdown') === false) {
						currentTag = currentTag.parentNode;
					}

					if (currentTag === null) {
						that.openDropdown.click();
					}
				}
			});
		}
	};


	return toggleLink;
}));


//////////////////
// WEBPACK FOOTER
// ./components/toggleLink/toggleLink.js
// module id = 2
// module chunks = 0